<div class="card cursor-pointer" (click)="openPodcastDetail()">
  <div class="aspect-w-12 aspect-h-8 rounded-card overflow-hidden bg-theme-gray-three">
    <div>
      <img
        *ngIf="podcast?.picture"
        [src]="podcast?.picture"
        class="absolute top-0 bottom-0 right-0 left-0 object-cover object-center w-full h-full"
      />

      <div class="absolute top-0 bottom-0 right-0 left-0 flex items-center justify-center">
        <div
          class="bg-white bg-opacity-50 text-white w-[47px] h-[47px] flex items-center justify-center rounded-full"
        >
          <svg-icon
            src="assets/images/svg-icons/icon-triangle.svg"
            [svgStyle]="{ 'width.px': '14' }"
          ></svg-icon>
        </div>
      </div>

      <div
        class="absolute top-4 left-4 right-4 flex items-start justify-between space-x-4 max-w-full"
        *ngIf="podcast?.course.specialties[0]"
      >
        <div
          class="flex items-center space-x-4 bg-black bg-opacity-30 py-2 px-4 rounded text-12 text-white max-w-full min-w-0"
        >
          <span class="truncate">{{ podcast.course.displayName }}</span>
          <img [src]="podcast?.course.specialties[0].icon" class="h-[22px] w-[22px] rounded-full" />
        </div>
        <div
          *ngIf="languageService.isParticipationNumbersEnabled"
          class="flex items-center space-x-4 bg-black bg-opacity-30 py-2 px-4 rounded text-12 text-white shrink-0"
        >
          <svg-icon
            src="assets/images/svg-icons/icon-eye.svg"
            [svgStyle]="{ 'width.px': '17' }"
          ></svg-icon>
          <span>{{ podcast?.totalViews }}</span>
        </div>
      </div>

      <div
        *ngIf="podcast"
        class="video-theme absolute bottom-0 left-0 right-0 min-h-[80px] flex flex-col justify-end p-4 text-white font-extrabold text-18"
      >
        <span>{{ podcast.title }}</span>
      </div>
    </div>
  </div>
</div>
